import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Modal, { ModalFooter } from '~/components/Modal';
import { resendEmailConfirmation } from '~/store/modules/auth/actions';
import Button from '~/components/Button';

import * as S from './styles';

const ModalSendConfirm = ({ isOpen, setModaIsOpen, email }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleModalisOpen = () => {
    setModaIsOpen(false);
  };

  const handleSendConfirmationEmail = () => {
    dispatch(resendEmailConfirmation({ email }));
    setModaIsOpen(false);
  };

  return (
    <Modal
      maxWidth="450px"
      title="Ativar sua conta"
      isOpen={isOpen}
      onClose={handleModalisOpen}
    >
      <S.ContainerBody>
        <p>
          {t('signin.modal_send_confirm_email.text_hello')}{' '}
          <span> {email}</span>
        </p>

        <p>{t('signin.modal_send_confirm_email.text_steps')}</p>
      </S.ContainerBody>

      <ModalFooter>
        <Button
          color="primary"
          variant="fill"
          size="medium"
          onClick={handleSendConfirmationEmail}
        >
          {t('Reenviar email de ativação')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalSendConfirm.propTypes = {
  isOpen: PropTypes.bool,
  setModaIsOpen: PropTypes.func,
  email: PropTypes.string,
};

ModalSendConfirm.defaultProps = {
  isOpen: false,
  setModaIsOpen: ModalSendConfirm.handleModalisOpen,
  email: '',
};

export default ModalSendConfirm;
